module.exports = __webpack_public_path__ + "static/media/Cuadricula_5.c66a1984.svg";